import { utilBuildings } from "../../../utils/utilBuildings";
import { selectBuildingsProducingOrFinishedProductionResourceAvailable } from "../selectors/selectBuildingsProducingOrFinishedProductionResourceAvailable";
import { createPathSelectBuildingMaxLevel } from "./createPathSelectBuildingMaxLevel";
export var pathSelectPremiumBuildingNotProducingMaxLevelByResourceId = function (action, state$, deps) {
    return createPathSelectBuildingMaxLevel(function () {
        var state = state$.value;
        var resourceId = action.taskType.resourceId;
        var availableBuildings = selectBuildingsProducingOrFinishedProductionResourceAvailable(state, resourceId);
        return availableBuildings
            .filter(utilBuildings.isNotProducing)
            .filter(utilBuildings.isPremium);
    })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/pathSelectPremiumBuildingNotProducingMaxLevelByResourceId.ts
// module id = 2387
// module chunks = 3